export const docsBaseUrl = "https://docs.seniorplace.io";
